
import { DetectionResult } from './types';

/**
 * Calculate Shannon entropy of text (measure of information density)
 * @param text Input text to analyze
 * @returns Shannon entropy value
 */
export function calculateTextEntropy(text: string): number {
  const frequencies: {[key: string]: number} = {};
  const cleanText = text.toLowerCase().replace(/[^a-z]/g, '');
  
  // Count character frequencies
  for (const char of cleanText) {
    frequencies[char] = (frequencies[char] || 0) + 1;
  }
  
  // Calculate entropy
  let entropy = 0;
  const len = cleanText.length;
  
  for (const char in frequencies) {
    const probability = frequencies[char] / len;
    entropy -= probability * Math.log2(probability);
  }
  
  return entropy;
}

/**
 * Detect ratio of non-English characters (simplified)
 * @param text Input text to analyze
 * @param ignoreSpaces Whether to ignore spaces (default: true)
 * @returns Ratio of non-English characters (0-1)
 */
export function detectNonEnglishRatio(text: string, ignoreSpaces: boolean = true): number {
  // Define common ASCII characters in English
  const englishCharSet = /[a-zA-Z0-9 .,?!;:()'"\-]/g;
  const cleanText = ignoreSpaces ? text.replace(/\s/g, '') : text;
  const englishChars = (text.match(englishCharSet) || []).length;
  
  return 1 - (englishChars / cleanText.length);
}
